import * as MODALS_LIB from "Helpers/modals";

export default {
  data: () => ({
    staged_models: [],
  }),
  beforeMount() {
    /**
     * From Helpers/modals
     */
    Object.entries(MODALS_LIB).filter(entry => typeof entry[1] === 'function').forEach(([name, fn]) => {
      this[name] = fn.bind(this); // using .bind to pass 'this' context
    });
  },
};
